module.exports = {"noData":"Dáta nie sú k dispozícii","tab.distribution":"Rozloženie v krajoch","tab.ownership":"Listy vlastníctva"}